/* eslint-disable prettier/prettier */

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { _object } from 'utils/interfaces'

const CustomDatePicker = ({ label, name, value, onChange }: _object) => {
  return (
    <div className="mb-4">
      <label className="mb-1 block text-sm font-medium text-gray-700">{label}</label>
      <DatePicker
        selected={value ? new Date(value) : null}
        onChange={(date) => {
          onChange({ target: { name, value: date?.toISOString().split('T')[0] } })
        }}
        dateFormat="yyyy-MM-dd"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        placeholderText="YYYY-MM-DD"
        maxDate={new Date()}
        className="mb-2 w-[400px] rounded-md border bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none  border-transparent"
      />
    </div>
  )
}

export default CustomDatePicker
